<template>
  <span
    :style="setPanoramaInvoiceStatusColorMap()"
    class="panorama-invoice-status"
  >
    {{ getAbbreviatedPanoramaInvoiceStatus() }}
  </span>
</template>

<script>
import { RenderMoneyColumnValue } from '../../../ui/render';
import { setPanoramaInvoiceStatusColor } from '../utils';
import {
  ABBREVIATED_PANORAMA_INVOICE_STATUS,
  PANORAMA_INVOICE_STATUS,
} from '../constants';

export default {
  components: { RenderMoneyColumnValue },
  props: {
    panoramaInvoiceStatus: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    getAbbreviatedPanoramaInvoiceStatus() {
      return this.panoramaInvoiceStatus
        ? ABBREVIATED_PANORAMA_INVOICE_STATUS[this.panoramaInvoiceStatus]
        : '';
    },
    setPanoramaInvoiceStatusColorMap() {
      return this.panoramaInvoiceStatus
        ? setPanoramaInvoiceStatusColor(
            PANORAMA_INVOICE_STATUS[this.panoramaInvoiceStatus],
          )
        : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.panorama-invoice-status {
  font-weight: 700;
}
</style>
